import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';
export var routingSelector = function routingSelector(state) {
  return state.router.location;
};
export var authSelector = function authSelector(state) {
  return state.auth;
};
/**
 * We need to use isEqual for equalityCheck, otherwise firebase.listeners compared
 * by === breaks memoization
 */

export var firebaseSelector = createSelectorCreator(defaultMemoize, isEqual)(function (state) {
  return state.firebase;
}, function (firebase) {
  return firebase;
});